export function getSession(TokenKey: string) {
  return localStorage.getItem(TokenKey);
}

export function setSession(TokenKey: string, tokenValue: any) {
  localStorage.setItem(TokenKey, tokenValue);
}

export function removeToken(TokenKey: string) {
  localStorage.removeItem(TokenKey);
}
export function removeStroage(TokenKey: string) {
  localStorage.removeItem(TokenKey);
}

export function getUrlKey(name) {
  const arr = ['', ''];
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || arr)[1].replace(/\+/g, '%20')
    ) || null
  );
}

export const localhrefHome = () => {
  window.location.href = '/#/';
};
